export default __webpack_public_path__ + "static/media/SY.6d7188f8.svg";